import React, { useState } from "react";
import styled from "styled-components";

export const Wrapper = styled.div`
height: 1009px;
width: 100%;
background: #F5F5F6;

left: 0;

display: flex;
flex-direction:column;

align-items: center;
justify-content: center;
`;

export const NavTitle = styled.div`
  position: relative;

  font-family: Noto Sans KR;
  font-style: normal;
  font-weight: bold;
  font-size: ${(props) => props.fontSize || 28}px;
  line-height: 35px;

  display: flex;
  align-items: center;
  justify-content: center;

  color: ${(props) => props.color || "#333333"};

  margin-bottom: ${(props) => props.marginBottom}px;
  margin-top: ${(props) => props.marginTop}px;
  margin-left: ${(props) => props.marginLeft}px;

  span {
    font-weight: normal;
    font-size: 17px;
  }
`;

export const NavText = styled.div`
  position: relative;

  font-family: Noto Sans KR;
  font-style: normal;
  font-weight: normal;
  font-size: ${(props) => props.fontSize || 17}px;
  line-height: ${(props) => props.lineHeigh || 25}px;

  margin-top: ${(props) => props.marginTop || 10}px;
  margin-bottom: ${(props) => props.marginBottom || 40}px;
  letter-spacing: ${(props) => props.letterSpacing || -0.01}em;

  color: ${(props) => props.color || "#555555"};
`;

export const TableContainer = styled.div`
margin-top : 60px;
margin-left: 120px;
width: 80%;
height: 70%;

display: flex;
justify-content: center;
align-items: center;
`;